import { forwardRef } from 'react';

import { Chip, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  tag: {
    borderRadius: theme.spacing(1 / 2),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(0, 2, 2, 0),
    },
  },
}));

const ChipCategory = forwardRef((props, ref) => {
  const classes = useStyles();

  return (
    <Chip clickable component="a" className={classes.tag} color="primary" ref={ref} {...props} />
  );
});

ChipCategory.propTypes = {};
ChipCategory.displayName = 'ChipCategory';

export default ChipCategory;
